import {
    IonIcon, IonItem
} from '@ionic/react';
  import React from 'react';
  import { logOutOutline} from 'ionicons/icons';
  import { useHistory } from 'react-router';

  const LogoutPage: React.FC = () => {
  const history = useHistory();
      
    const signout = ()=> {
        localStorage.removeItem("authToken");
        localStorage.removeItem("username");
        localStorage.clear();
        history.push("/Login");
    }

        return (
            <IonItem lines="none" onClick={signout} >
            <IonIcon color = "primary" slot="end" icon={logOutOutline} style={{fontSize : "40px", paddingTop: "10px"}} />
            </IonItem>
        );
      };

    export default LogoutPage;